import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import linearDownload from '../../assets/img/linear-download.svg';

export interface CaiDownloadType {
    imgPath: string;
    url?: string;
    companyName?: string;
}

const CaiDownload = ({ imgPath, url, companyName }: CaiDownloadType) => {
    return (
        <a target="_blank" href={url} rel="noreferrer">
            <Wrapper imgPath={imgPath} companyName={companyName}>
                <DownloadBtn companyName={companyName}>{companyName === "LINEAR" ? <img
                    src={linearDownload}
                    alt="TrashBin"
                    style={{ width: "20px" }}
                /> : <FontAwesomeIcon icon={faDownload} />}</DownloadBtn>
            </Wrapper>
        </a>
    )
}

const Wrapper = styled.div<CaiDownloadType>`
    position: relative;
    width: 100px;
    height: 150px;
    border: ${props => props.companyName === "LINEAR" ? "2px solid #499640" : "2px solid #3079C9"};
    border-radius: ${props => props.companyName === "LINEAR" && "8px"};
    background-image: url(${props => props.imgPath});
    background-size: cover;
`

export interface DownloadProps {
    companyName?: string;
}

const DownloadBtn = styled.div<DownloadProps>`
    position: absolute;
    bottom: -10px;
    right: -10px;
    height: 40px;
    width: 40px;
    background-color: ${props => props.companyName === "LINEAR" ? "#FFF" : "#3079C9"};
    border-radius: 50%;
    border: ${props => props.companyName === "LINEAR" && "1px solid #499640"};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        color: ${props => props.companyName === "LINEAR" ? "2px solid #499640" : "#FFF"};
    }
`

export default CaiDownload